import * as ArrayUtils from "../../../../../utils/ArrayUtil";
import {GenericChecker} from "../GenericChecker";

export class AllergyChecker extends GenericChecker {
    static isDataEntered(allergy) {
        return allergy != null && !ArrayUtils.isEmpty(allergy.items);
    }
}
